import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Typography,
} from "@mui/material";
import React from "react";
import { usePagesTranslation } from "../../../../pages/locales";

/**
 * Apple-required first step: explicit permanent-delete warning before the data-deletion API flow.
 */
export default function DeleteAccountConfirmDialog({ open, onClose, onConfirm, confirming = false }) {
    const { t } = usePagesTranslation();

    return (
        <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
            <DialogTitle sx={{ fontWeight: 700 }}>
                {t("native.settings.deleteAccountConfirmTitle", {
                    defaultValue: "Delete account?",
                })}
            </DialogTitle>
            <DialogContent>
                <Typography variant="body1" sx={{ lineHeight: 1.5 }}>
                    {t("native.settings.deleteAccountConfirmBody", {
                        defaultValue:
                            "Are you sure? This action is permanent. Your profile and play history will be completely removed, and you will be signed out.",
                    })}
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ mt: 1.5, lineHeight: 1.45 }}>
                    <Typography component="span" variant="body2" sx={{ fontWeight: 700, color: "text.primary" }}>
                        {t("native.settings.deleteAccountConfirmImportantNote", {
                            defaultValue: "Important Note:",
                        })}{" "}
                    </Typography>
                    {t("native.settings.deleteAccountConfirmSubscriptionNote", {
                        defaultValue:
                            "Deleting your account does not automatically cancel your Premium subscription. Please ensure you cancel your active subscription in your App Store or Google Play account settings to prevent future charges.",
                    })}
                </Typography>
            </DialogContent>
            <DialogActions sx={{ px: 2, pb: 2, gap: 1 }}>
                <Button onClick={onClose} disabled={confirming} sx={{ minHeight: 44 }}>
                    {t("btn.cancel", { defaultValue: "Cancel" })}
                </Button>
                <Button
                    onClick={onConfirm}
                    color="error"
                    variant="contained"
                    disabled={confirming}
                    sx={{ minHeight: 44 }}
                >
                    {t("native.settings.deleteAccount", { defaultValue: "Delete Account" })}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
